import script from "./MDataTableExpandButton.vue?vue&type=script&setup=true&lang=js"
export * from "./MDataTableExpandButton.vue?vue&type=script&setup=true&lang=js"

import "./MDataTableExpandButton.vue?vue&type=style&index=0&id=1afd5d51&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1afd5d51"]])

export default __exports__